import * as types from "./Types";
import { IDashboardMessage } from "../Models/Models";
import * as DashboardMessageLogic from "../Logic/DashboardMessageLogic";
import { ActiveApp } from "../Enums/Enums";

declare let scout;

export const loadScout = (data = true) => ({
    type: types.LOAD_SCOUT,
    data: data,
});

export const setScoutIsShowing = (scoutIsShowing: boolean) => ({
    type: types.SET_SCOUT_IS_SHOWING,
    data: scoutIsShowing,
});

export const setActiveApp = (activeApp: ActiveApp) => ({
    type: types.SET_ACTIVE_APP,
    data: activeApp,
});

export const setShowSplashScreen = (showSplashScreen: boolean) => ({
    type: types.SET_SHOW_SPLASH_SCREEN,
    data: showSplashScreen,
});

export const loadDefaultBookmark = () => {
    const message: IDashboardMessage = {
        targetElement: "dashboardMessageReceiverDefaultBookmark",
        message: {
            text: "LOAD_DEFAULT_BOOKMARK",
            data: true,
        },
    };

    DashboardMessageLogic.sendDashBoardMessage(message);
};

export const sendMessageShowScout = () => {
    const message: IDashboardMessage = {
        targetElement: "dashboardMessageReceiverTopNav",
        message: {
            text: "SHOW_SCOUT",
            data: null,
        },
    };

    DashboardMessageLogic.sendDashBoardMessage(message);
};

export const sendMessageScoutSearch = () => {
    const message: IDashboardMessage = {
        targetElement: "dashboardMessageReceiverTopNav",
        message: {
            text: "SEARCH",
            data: null,
        },
    };

    DashboardMessageLogic.sendDashBoardMessage(message);
};

export const sendMessageShowDashboard = () => {
    const message: IDashboardMessage = {
        targetElement: "dashboardMessageReceiverTopNav",
        message: {
            text: "SHOW_DASHBOARD",
            data: null,
        },
    };

    DashboardMessageLogic.sendDashBoardMessage(message);
};

export const sendMessageShowReports = () => {
    const message: IDashboardMessage = {
        targetElement: "dashboardMessageReceiverTopNav",
        message: {
            text: "SHOW_REPORTS",
            data: null,
        },
    };

    DashboardMessageLogic.sendDashBoardMessage(message);
};

export const sendMessageShowRetailMatches = () => {
    const message: IDashboardMessage = {
        targetElement: "dashboardMessageReceiverTopNav",
        message: {
            text: "SHOW_MATCHES",
            data: null,
        },
    };

    DashboardMessageLogic.sendDashBoardMessage(message);
};

export const loadScoutIfNeeded = (activeApp: ActiveApp): void => {
    const scoutContainer = document.getElementById("experimental-scout");
    const scoutAppItems = scoutContainer.getElementsByClassName("sct-workspace");

    if (
        activeApp === ActiveApp.SCOUT
    || activeApp === ActiveApp.BOOKMARKS
    || activeApp === ActiveApp.RETAIL_MATCHES
    ) {
        scoutContainer.style.display = null;
        for (let i = 0; i < scoutAppItems.length; i++) {
            scoutAppItems[i].classList.remove("visible");
        }

    // if (!scout.appIsReady) {
    //     scout.actions.initialize();
    // }
    }
};
